import { createFileRoute, Link } from '@tanstack/react-router';
import { Plus } from 'lucide-react';

import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { CustomerList } from '@/components/customers/CustomerList';

export const Route = createFileRoute('/admin/customers/')({
  component: CustomersPage,
});

function CustomersPage() {
  return (
    <div className="space-y-6 p-6 duration-300 animate-in fade-in">
      <PageHeader
        title="Customers"
        description="View and manage customer accounts."
        actions={
          <Button size="sm" asChild>
            <Link to="/admin/customers/new">
              <Plus className="size-4" />
              Add Customer
            </Link>
          </Button>
        }
      />

      <CustomerList />
    </div>
  );
}
